import {
  Box,
  FormControl,
  FormHelperText,
  IconButton,
  InputAdornment,
  OutlinedInput,
} from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import PlacesAutocomplete from "react-places-autocomplete";
import { suggestionBackgroundColor } from "../../BookingStyle";

const placeSearchOptions = {
  componentRestrictions: { country: "PE" },
};

const OriginAutocompleteField = ({
  value,
  placeholder,
  onChange,
  onSelect,
  onInputChange,
  onMapClick,
  error = false,
}) => (
  <PlacesAutocomplete
    value={value}
    onChange={onChange}
    onSelect={onSelect}
    searchOptions={placeSearchOptions}
  >
    {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
      <div key={suggestions.description}>
        <FormControl fullWidth variant="outlined" error={error}>
          <OutlinedInput
            id="outlined-adornment-weight"
            error={error}
            onChange={onInputChange}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  size="small"
                  onClick={onMapClick}
                  edge="end"
                  sx={{
                    color: "primary.main",
                    transition: "background-color 0.2s ease, color 0.2s ease",
                    "&:hover": {
                      bgcolor: "primary.main",
                      color: "common.white",
                    },
                  }}
                >
                  <LocationOnIcon fontSize="medium" />
                </IconButton>
              </InputAdornment>
            }
            aria-describedby="outlined-weight-helper-text"
            {...getInputProps({
              placeholder,
              className: "location-search-input",
            })}
          />
          {error && <FormHelperText>Ingrese el origen</FormHelperText>}
        </FormControl>
        <Box
          key={suggestions.description}
          className="autocomplete-dropdown-container suggestions"
        >
          {loading && <div>Loading...</div>}
          {suggestions.map((suggestion) => {
            const className = suggestion.active
              ? "suggestion-item--active"
              : "suggestion-item";
            const style = suggestion.active
              ? suggestionBackgroundColor("#fafafa")
              : suggestionBackgroundColor("#ffffff");
            return (
              <div
                key={suggestion.description}
                {...getSuggestionItemProps(suggestion, {
                  className,
                  style,
                })}
              >
                <span>{suggestion.description}</span>
              </div>
            );
          })}
        </Box>
      </div>
    )}
  </PlacesAutocomplete>
);

export default OriginAutocompleteField;
